import { alpha } from '@mui/material';
const useTableStyles = () => {
    return {
        tableContainer: {
            overflowX: 'auto',
            borderRadius: '14px',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            // backgroundColor: alpha('#25292D', 0.3),
            '& .MuiTable-root': {
                borderCollapse: 'separate',
                borderSpacing: 0
            }
        },
        headerRow: {
            '& .MuiTableCell-root': {
                // borderBottom: '1px solid #00B6ED',
                fontWeight: 400,
                ...(theme) => theme.typography.body2,
                fontSize: '14px',
                color: (theme) => theme.palette.text.primary,
                background: (theme) => theme.palette.common.white,
                backdropFilter: 'blur(40px)',
                backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                padding: (theme) => theme.spacing(2),
                // borderRadius:(theme)=> theme.spacing(2)
                '&:first-of-type': {
                    borderTopLeftRadius: 14,
                    borderBottomLeftRadius: 14
                },
                '&:last-of-type': {
                    borderBottomRightRadius: 14,
                    borderTopRightRadius: 14
                }
            }
        },
        firstHeadCell: {
            // fontWeight: 600,
            // fontSize: '14px',
            ...(theme) => theme.typography.body2,
            color: (theme) => theme.palette.text.secondary,
            borderTopLeftRadius: 14,
            // borderBottom: '1px solid #00B6ED',
            backgroundColor: 'transparent',
            backdropFilter: 'blur(40px)',
            padding: (theme) => theme.spacing(2)
        },
        headCell: {
            ...(theme) => theme.typography.body2,
            fontWeight: 500,
            color: (theme) => theme.palette.text.secondary,
            // borderBottom: '1px solid #00B6ED',
            backgroundColor: 'transparent',
            backdropFilter: 'blur(40px)',
            padding: (theme) => theme.spacing(2)
        },
        lastHeadCell: {
            // fontWeight: 600,
            // fontSize: '14px',
            // color: '#00B6ED',
            ...(theme) => theme.typography.body2,
            color: (theme) => theme.palette.text.secondary,
            borderTopRightRadius: 14,
            // borderBottom: '1px solid #00B6ED',
            backgroundColor: 'transparent',
            // backdropFilter: 'blur(40px)',
            padding: (theme) => theme.spacing(2)
        },
        bodyRow: {
            color: (theme) => theme.palette.text.primary,
            cursor: 'pointer',
            '& .MuiTableCell-root': {
                borderBottom: '1px solid transparent',
                color: (theme) => theme.palette.text.primary,
                fontWeight: 400,
                padding: (theme) => theme.spacing(2),
                transition: 'all 0.2s ease-in-out'
            },
            '&:last-child .MuiTableCell-root': {
                borderBottom: 'none',
                '&:first-of-type': {
                    borderBottomLeftRadius: 14
                },
                '&:last-of-type': {
                    borderBottomRightRadius: 14
                }
            }
        },
        bodyCell: {
            borderBottom: '1px solid transparent',
            color: (theme) => theme.palette.text.primary,
            fontWeight: 400,
            padding: (theme) => theme.spacing(2)
        },
        moduleCell: {
            fontWeight: 500,
            color: (theme) => theme.palette.text.primary
        },
        switchCell: {
            '& .MuiSwitch-root': {
                '& .MuiSwitch-switchBase': {
                    color: '#C4CDD5',
                    '&.Mui-checked': {
                        color: '#00B6ED',
                        '& + .MuiSwitch-track': {
                            backgroundColor: '#00B6ED',
                            opacity: 0.5
                        }
                    }
                },
                '& .MuiSwitch-track': {
                    backgroundColor: alpha('#C4CDD5', 0.3)
                }
            }
        }
    };
};
export default useTableStyles;
